// src/slices/5-formsWorkSpace/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { submitTrainingForm, submitMeetingForm, submitMediaAgencyForm, submitConsultingForm, submitBookingForm, fetchPaperworkRequests, submitPaperworkRequest, submitIssueReport } from "./thunk";

import { toast } from "react-toastify";

const initialState = { paperwork: [], loading: false, error: null, data: { training: null, meeting: null, mediaAgency: null, consulting: null, booking: null, issueReport: null } };

const formsSlice = createSlice({
  name: "forms",
  initialState,
  reducers: {
    clearForms: (state) => {
      state.error = null;
      state.loading = false;
      state.data = { training: null, meeting: null, mediaAgency: null, consulting: null, booking: null };
    }
  },

  extraReducers: (builder) => {
    const handlePending = (state) => {
      state.loading = true;
      state.error = null;
    };

    const handleRejected = (state, action) => {
      state.loading = false;
      state.error = action.payload;
      toast.error(action.payload);
    };

    builder

      // =========================
      // TRAINING FORM
      // =========================
      .addCase(submitTrainingForm.pending, handlePending)
      .addCase(submitTrainingForm.fulfilled, (state, action) => {
        state.loading = false;
        state.data.training = action.payload;
        toast.success("Training form submitted successfully");
      })
      .addCase(submitTrainingForm.rejected, handleRejected)

      // =========================
      // MEETING FORM
      // =========================
      .addCase(submitMeetingForm.pending, handlePending)
      .addCase(submitMeetingForm.fulfilled, (state, action) => {
        state.loading = false;
        state.data.meeting = action.payload;
        toast.success("Meeting form submitted successfully");
      })
      .addCase(submitMeetingForm.rejected, handleRejected)

      // =========================
      // MEDIA AGENCY FORM
      // =========================
      .addCase(submitMediaAgencyForm.pending, handlePending)
      .addCase(submitMediaAgencyForm.fulfilled, (state, action) => {
        state.loading = false;
        state.data.mediaAgency = action.payload;
        toast.success("Media agency form submitted successfully");
      })
      .addCase(submitMediaAgencyForm.rejected, handleRejected)

      // =========================
      // CONSULTING FORM
      // =========================
      .addCase(submitConsultingForm.pending, handlePending)
      .addCase(submitConsultingForm.fulfilled, (state, action) => {
        state.loading = false;
        state.data.consulting = action.payload;
        toast.success("Consulting form submitted successfully");
      })
      .addCase(submitConsultingForm.rejected, handleRejected)

      // =========================
      // BOOKING FORM
      // =========================
      .addCase(submitBookingForm.pending, handlePending)
      .addCase(submitBookingForm.fulfilled, (state, action) => {
        state.loading = false;
        state.data.booking = action.payload;
        toast.success("Booking form submitted successfully");
      })
      .addCase(submitBookingForm.rejected, handleRejected)

      // --- GET Paperwork ---
      .addCase(fetchPaperworkRequests.pending, handlePending)
      .addCase(fetchPaperworkRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.paperwork = action.payload;
      })
      .addCase(fetchPaperworkRequests.rejected)

      // --- POST Paperwork ---
      .addCase(submitPaperworkRequest.pending, handlePending)
      .addCase(submitPaperworkRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.paperwork = action.payload;
        toast.success("Paperwork request submitted successfully");
      })
      .addCase(submitPaperworkRequest.rejected, handleRejected)

      // =========================
      // ISSUE REPORT FORM
      // =========================
      .addCase(submitIssueReport.pending, handlePending)
      .addCase(submitIssueReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data.issueReport = action.payload;
        toast.success("Issue report submitted successfully");
      })
      .addCase(submitIssueReport.rejected, handleRejected);
  }
});

export const { clearForms } = formsSlice.actions;
export default formsSlice.reducer;
